module.exports = __webpack_public_path__ + "media/images/case-studies/baw-baw-51cace68ea6bcdd32e91e17889f81050.png";